module.exports = __webpack_public_path__ + "img/DeskStationaryA05.09174749.png";